import './i18n.js';
import { createRoot } from 'react-dom/client';
import App from './App';

// After a new deployment, hashed chunk filenames change.
// Users with cached pages get "Failed to fetch dynamically imported module".
// Catch it and force a fresh reload so they get the new build.
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

createRoot(document.getElementById('root')).render(<App />);
